// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Хочу получать COOKIE */
.cookie-container {
    padding: 5px 10px;
    font-size: 12px;
    color: #000000;
    opacity: 0.9;
    position: fixed;
    right: 0;
    bottom: 0;
    flex-direction: row;
    align-items: center;
    background-color: #ffffff;
    gap: 10px;
    z-index: 100000;
}

.cookie-container__text-pc {
    display: inline-block;
}

.cookie-container__link {
    cursor: pointer;
    text-decoration: underline !important;
}

.cookie-container__button {
    border-radius: 7px;
    border: 1px solid #000000;
    padding: 5px 10px;
    text-align: center;
    background: #ffffff;
}

@media all and (max-width: 768px) {
    .cookie-container__text-pc {
        display: none;
    }

    .cookie-container {
        left: 0;
        bottom:68px;
    }
}
`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/cookie.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,OAAO;QACP,WAAW;IACf;AACJ","sourcesContent":["/* Хочу получать COOKIE */\n.cookie-container {\n    padding: 5px 10px;\n    font-size: 12px;\n    color: #000000;\n    opacity: 0.9;\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    flex-direction: row;\n    align-items: center;\n    background-color: #ffffff;\n    gap: 10px;\n    z-index: 100000;\n}\n\n.cookie-container__text-pc {\n    display: inline-block;\n}\n\n.cookie-container__link {\n    cursor: pointer;\n    text-decoration: underline !important;\n}\n\n.cookie-container__button {\n    border-radius: 7px;\n    border: 1px solid #000000;\n    padding: 5px 10px;\n    text-align: center;\n    background: #ffffff;\n}\n\n@media all and (max-width: 768px) {\n    .cookie-container__text-pc {\n        display: none;\n    }\n\n    .cookie-container {\n        left: 0;\n        bottom:68px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
